<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  getUserInfo,
} from '@qx/utils/auth';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        isNeedBillOptions: [],
        form: [
          { // 操作类型
            label: '操作类型',
            value: 'businessType',
            type: 'select',
            default: -1,
            placeholder: '请选择操作类型',
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '转出',
                value: 4,
              },
              {
                label: '转入',
                value: 5,
              },
              {
                label: '转移',
                value: 6,
              },
              {
                label: '提现',
                value: 2,
              },
              {
                label: '充值',
                value: 1,
              },
            ],
          },
          { // 支付时间
            label: '支付时间',
            value: 'Date',
            type: 'date',
            placeholder: '请输入支付时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 业务方
            label: '业务方',
            value: 'userName',
            type: 'input',
            placeholder: '请输入业务方',
          },
          { // 支付流水
            label: '支付流水',
            value: 'flowId',
            type: 'input',
            placeholder: '请输入支付流水',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 付款账户名
            label: '付款账户名',
            value: 'payBankAccName',
            type: 'input',
            placeholder: '请输入付款账户名',
          },
          { // 收款账户名
            label: '收款账户名',
            value: 'accName',
            type: 'input',
            placeholder: '请输入收款账户名',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 票据类型
            label: '票据类型',
            value: 'isNeedBill',
            type: 'select',
            placeholder: '请选择票据类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      const userInfo = getUserInfo();
      if (searchBoxData.Date) {
        searchBoxData.beginPayTime = this.formatDate(searchBoxData.Date[0]);
        searchBoxData.endPayTime = this.formatDate(searchBoxData.Date[1]);
        delete searchBoxData.Date;
      }
      searchBoxData.userId = userInfo.staffTFInfo.userId;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'FUNDS_IS_NEED_BILL',
    });
    this.searchBoxData.isNeedBillOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
